// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	CancelButton: 'cancel-button',
	SearchButton: 'search-button',
	FirstName: 'first-name',
	LastName: 'last-name',
	Name: 'name',
	Number: 'number',
	FirstNameInputWrapper: 'first-name-input-wrapper',
	LastNameInputWrapper: 'last-name-input-wrapper',
	CompanyInputWrapper: 'company-input-wrapper',
	ExecutionNumberInputWrapper: 'execution-number-input-wrapper',
	SearchTypeRadioGroup: 'search-type-radio-group',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
